package one.devsbox.www.tools

import kotlinx.browser.document
import kotlinx.coroutines.suspendCancellableCoroutine
import org.w3c.dom.HTMLInputElement
import org.w3c.files.File
import kotlin.coroutines.resume

object FilePicker {

    suspend fun pickFile(contentTypes: List<String>): File? = suspendCancellableCoroutine { cont ->
        var canContinue = true
        cont.invokeOnCancellation {
            canContinue = false
        }
        val inputElement = document.createElement("input") as HTMLInputElement
        inputElement.type = "file"
        inputElement.multiple = false
        inputElement.accept = contentTypes.joinToString(",")

        inputElement.asDynamic().oncancel = {
            if (cont.isActive && canContinue) {
                canContinue = false
                cont.resume(null)
            }
        }

        inputElement.onchange = {
            if (cont.isActive && canContinue) {
                canContinue = false
                val fileList = inputElement.files
                val selectedFile = if (fileList != null && fileList.length > 0) fileList.item(0) else null
                cont.resume(selectedFile)
            }
        }
        inputElement.click()
    }

    suspend fun uploadFile(
        file: File,
        uploadUrl: String,
        token: String,
        onProgress: (Int) -> Unit
    ): Boolean = suspendCancellableCoroutine { cont ->
        val xhr = org.w3c.xhr.XMLHttpRequest()
        xhr.open("PUT", uploadUrl, true)
        xhr.setRequestHeader("Content-Disposition", "attachment; filename=\"${file.name}\"")
        xhr.setRequestHeader("data-size", file.size.toString())
        xhr.setRequestHeader("Authorization", "Bearer $token")

        xhr.upload.asDynamic().onprogress = { event: dynamic ->
            val loaded = event.loaded as Double
            val total = event.total as Double
            if (total > 0) {
                val percent = ((loaded / total) * 100).toInt()
                onProgress(percent)
            }
        }

        xhr.onload = {
            if (xhr.status == 200.toShort()) {
                cont.resume(true)
            } else {
                cont.resume(false)
            }
        }

        xhr.onerror = {
            cont.resume(false)
        }

        xhr.send(file)

        cont.invokeOnCancellation {
            xhr.abort()
        }
    }
}
